module.exports = __webpack_public_path__ + "static/outros-procedimento-409846fbc15246d750764e4179438bbf.jpg";